import * as _ from 'lodash';
import * as moment from 'moment';

export interface ITableService {
  exportAsExcel(dataSource: Array<any>, columns: Array<any>): void;

  exportHtmlToExcel(table: string, filename: string): void;
}

export class TableService implements ITableService {
  public async exportAsExcel(dataSource: Array<any>, columns: Array<any>) {
    const rows = [{
      cells: _.map(columns, column => ({value: column.label}))
    }];

    _.forEach(dataSource, (val, key) =>
        rows.push({
          cells: _.map(columns, column => ({
            value: val[column.field]
          }))
        })
    );

    const workbook = this._createWorkbook(dataSource, rows);
    // save the file as Excel file with extension xlsx
    try {
      kendo.saveAs({
        dataURI: workbook.toDataURL(),
        fileName: `${moment().format('YYYYMMDD-hhmmss')}_gig-chart-table.xlsx`
      });
      return true;
    } catch (err) {
      return err;
    }
  }

  public exportHtmlToExcel(table: string, filename: string) {
    // const template = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel;charset=UTF-8"><head></head><body><table>${table}</table></body></html>`;
    const template = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel;charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>${'worksheet'}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>${table.replace(/<img[^>]*>/g, '')}</table></body></html>`;
    const blob = new Blob([template], {
      type: 'application/vnd.ms-excel;charset=UTF-8'
    });

    kendo.saveAs({
      dataURI: window.URL.createObjectURL(blob),
      fileName: filename || `${moment().format('YYYYMMDD-hhmmss')}_gig-chart-table.xls`
    });
  }

  private _createWorkbook(dataSource: Array<any>, rows: Array<any>) {
    return new kendo.ooxml.Workbook({
      sheets: [
        {
          columns: _.map(_.range(0, dataSource.length + 1), () => ({autoWidth: true})),
          rows
        }
      ]
    });
  }
}

export const tableService = new TableService();
